import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import React from "react";
import LoginForm from "../components/users/LoginForm";
import App from "../components/App/App";
import { NotFound, ServerError } from "../components/errors/ErrorPanel";
import RequireNoAuth from "./RequireNoAuth";
import HomePage from "../components/Home/HomePage";
import CompanyPage from "../components/Company/CompanyPage";
import AccordionsPage from "../components/Accordions/AccordionsPage";
import AccordionDetailedPage from "../components/Accordions/AccordionDetailedPage/AccordionDetailedPage";
import ContactPage from "../components/Contact/ContactPage";
import ShopShortcut from "../components/ShopShortcut/ShopShortcut";
import AccessoriesPage from "../components/Accessories/AccessoriesPage";
import TeamPage from "../components/Team/TeamPage";

// Constants for routes can be defined here
const ROUTE_HOME = '/';
const ROUTE_LOGIN = '/login';
const ROUTE_CONTACT = '/Contact';
const ROUTE_COMPANY = '/Company';
const ROUTE_ACCORDIONS = '/Accordions';
const ROUTE_ACCESSORIES = '/Accessories';
const ROUTE_NOT_FOUND = '/not-found';
const ROUTE_SERVER_ERROR = '/server-error';
const ROUTE_TEAM = '/team'

export const routes: RouteObject[] = [
    {
        path: ROUTE_HOME,
        element: <App />,
        children: [
            {
                element: <RequireNoAuth />, children: [
                    { path: ROUTE_LOGIN, element: <LoginForm /> },
                    { path: ROUTE_HOME, element: <HomePage /> },
                    { path: ROUTE_ACCORDIONS, element: <ShopShortcut /> },
                    { path: `${ROUTE_ACCORDIONS}/buy`, element: <AccordionsPage mode={'buy'} /> },
                    { path: `${ROUTE_ACCORDIONS}/rent`, element: <AccordionsPage mode={'rent'} /> },
                    { path: `${ROUTE_ACCORDIONS}/:id`, element: <AccordionDetailedPage /> },
                    { path: ROUTE_CONTACT, element: <ContactPage /> },
                    { path: ROUTE_COMPANY, element: <CompanyPage /> },
                    { path: ROUTE_ACCESSORIES, element: <AccessoriesPage /> },
                    { path: ROUTE_TEAM, element: <TeamPage /> }
                ]
            },
            { path: ROUTE_NOT_FOUND, element: <NotFound /> },
            { path: ROUTE_SERVER_ERROR, element: <ServerError /> },
            { path: '*', element: <Navigate replace to={ROUTE_NOT_FOUND} /> },
        ]
    }
];

export const router = createBrowserRouter(routes);
